// extracted by mini-css-extract-plugin
export default {"cardContainer":"NotificationCard_cardContainer__lofIE","info":"NotificationCard_info__sHvgY","text":"NotificationCard_text__B+hz2"};